export default __webpack_public_path__ + "static/media/paxg.8ace88d0.svg";